import { func, object } from 'prop-types'
import { mapDataFromApi } from './FileBrowserView/utils'
import ManagedFilterBar from './FilterBarCore'

import './styles.scss'

const handleChange = (onChange, values) => {
  onChange(values.map((v) => v.id))
}

const FileBrowser = ({ filterTree, onChange, ...otherProps }) => (
  <ManagedFilterBar
    fileTree={mapDataFromApi(filterTree)}
    onChange={handleChange.bind(this, onChange)}
    {...otherProps}
  />
)

FileBrowser.propTypes = {
  filterTree: object,
  onChange: func,
}

export default FileBrowser
